var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6669 4.5H2.3335",
    stroke: "#D61E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5554 6.16663L12.2488 10.766C12.1308 12.536 12.0718 13.4209 11.4952 13.9605C10.9185 14.5 10.0315 14.5 8.25768 14.5H7.7421C5.96824 14.5 5.0813 14.5 4.50463 13.9605C3.92796 13.4209 3.86896 12.536 3.75096 10.766L3.44434 6.16663",
    stroke: "#D61E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 7.83337L6.66683 11.1667",
    stroke: "#D61E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 7.83337L9.3335 11.1667",
    stroke: "#D61E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 4.5C4.37075 4.5 4.38938 4.5 4.40626 4.49957C4.95522 4.48566 5.43951 4.13661 5.62631 3.62021C5.63205 3.60433 5.63794 3.58666 5.64972 3.55132L5.71445 3.35714C5.7697 3.19139 5.79733 3.1085 5.83397 3.03813C5.98017 2.75738 6.25066 2.56242 6.56324 2.51251C6.64158 2.5 6.72895 2.5 6.90367 2.5H9.09666C9.27138 2.5 9.35874 2.5 9.43709 2.51251C9.74967 2.56242 10.0202 2.75738 10.1664 3.03813C10.203 3.1085 10.2306 3.19138 10.2859 3.35714L10.3506 3.55132C10.3624 3.58661 10.3683 3.60434 10.374 3.62021C10.5608 4.13661 11.0451 4.48566 11.5941 4.49957C11.611 4.5 11.6296 4.5 11.6668 4.5",
    stroke: "#D61E1E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.342706da9186485400b8f8f516988312.svg";
export { ForwardRef as ReactComponent };